import PropTypes from 'prop-types';

export const UserPropTypes = PropTypes.shape({
  givenName: PropTypes.string,
  familyName: PropTypes.string,
});

export const ClientPropTypes = PropTypes.shape({
  clientId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
});

export const ClientsPropTypes = PropTypes.arrayOf(ClientPropTypes);

export const HelpContentPropTypes = PropTypes.shape({
  contentId: PropTypes.number.isRequired,
  icon: PropTypes.string,
  section: PropTypes.string,
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
});
